/**
 * amCharts 4 locale
 * 
 * Locale: en_MY
 * Language: Malay
 *
 * Follow instructions in [on this page](https://www.amcharts.com/docs/v4/tutorials/creating-translations/) to make corrections or add new translations.
 */
export default {
	// number formatter related
	"_decimalSeparator": ",",
	"_thousandSeparator": ".",

	// Default date formats for various periods
	"_date_millisecond": "mm:ss SSS",
	"_date_second": "HH:mm:ss",
	"_date_minute": "HH:mm",
	"_date_hour": "HH:mm",
	"_date_day": "dd MMM",
	"_date_week": "ww",
	"_date_month": "MMM",
	"_date_year": "yyyy",

	// Default duration formats for various base units
	"_duration_millisecond": "SSS",
	"_duration_second": "ss",
	"_duration_minute": "mm",
	"_duration_hour": "hh",
	"_duration_day": "dd",
	"_duration_week": "ww",
	"_duration_month": "MM",
	"_duration_year": "yyyy",

	// Era
	"_era_ad": "DC",
	"_era_bc": "AC",

	// Period
	"A": "",
	"P": "",
	"AM": "",
	"PM": "",
	"A.M.": "",
	"P.M.": "",

	// Dates
	"January": "Januari",
	"February": "Februari",
	"March": "Mac",
	"April": "April",
	"May": "Mei",
	"June": "Jun",
	"July": "Julai",
	"August": "Ogos",
	"September": "September",
	"October": "Oktober",
	"November": "November",
	"December": "Disember",
	"Jan": "Jan",
	"Feb": "Feb",
	"Mar": "Mac",
	"Apr": "Apr",
	"May(short)": "Mei",
	"Jun": "Jun",
	"Jul": "Jul",
	"Aug": "Ogo",
	"Sep": "Sep",
	"Oct": "Okt",
	"Nov": "Nov",
	"Dec": "Dis",
	"Sunday": "Ahad",
	"Monday": "Isnin",
	"Tuesday": "Selasa",
	"Wednesday": "Rabu",
	"Thursday": "Khamis",
	"Friday": "Jumaat",
	"Saturday": "Sabtu",
	"Sun": "Aha",
	"Mon": "Isn",
	"Tue": "Sel",
	"Wed": "Rab",
	"Thu": "Kham",
	"Fri": "Jum",
	"Sat": "Sab",

	// ordinal function
	"_dateOrd": function(day: number): string {
		return "º"
	},

	// Chart elements
	"Zoom Out": "Zoom Keluar",
	"Play": "Mainkan",
	"Stop": "Berhenti",
	"Legend": "Legend",
	"Click, tap or press ENTER to toggle": "",
	"Loading": "",
	"Home": "",

	// Chart types
	"Chart": "Carta",
	"Serial chart": "",
	"X/Y chart": "Carta X/Y",
	"Pie chart": "Carta Pai",
	"Gauge chart": "",
	"Radar chart": "Carta Radar",
	"Sankey diagram": "",
	"Chord diagram": "",
	"Flow diagram": "",
	"TreeMap chart": "",

	// Series types
	"Series": "Series",
	"Candlestick Series": "",
	"Column Series": "",
	"Line Series": "",
	"Pie Slice Series": "",
	"X/Y Series": "",

	// Map-related
	"Map": "Peta",
	"Press ENTER to zoom in": "Tekan ENTER untuk zum masuk",
	"Press ENTER to zoom out": "Tekan ENTER untuk zum keluar",
	"Use arrow keys to zoom in and out": "",
	"Use plus and minus keys on your keyboard to zoom in and out": "",

	// Export-related
	"Export": "Eksport",
	"Image": "Imej",
	"Data": "Data",
	"Print": "Cetak",
	"Click, tap or press ENTER to open": "Klik, ketik atau tekan ENTER untuk membuka",
	"Click, tap or press ENTER to print.": "Klik, ketik atau tekan ENTER untuk cetak",
	"Click, tap or press ENTER to export as %1.": "Klik, ketik atau tekan ENTER untuk mengeksport sebagai 1%.",
	'To save the image, right-click this link and choose "Save picture as..."': 'Untuk muat turun gambar, klik kanan pada pautan ini dan pilih "Muat turun gambar sebagai..."',
	'To save the image, right-click thumbnail on the left and choose "Save picture as..."': 'Untuk muat turun gambar, klik kanan pada gambar kecil di sebelah kiri dan pilih "Muat turun gambar sebagai..."',
	"(Press ESC to close this message)": "(Klik ESC untuk menutup mesej ini)",
	"Image Export Complete": "Eksport Imej Selesai",
	"Export operation took longer than expected. Something might have gone wrong.": "Operasi eksport mengambil masa lebih lama dari jangkaan. Kemungkinan ia menghadapi masalah.",
	"Saved from": "Simpan dari",
	"PNG": "",
	"JPG": "",
	"GIF": "",
	"SVG": "",
	"PDF": "",
	"JSON": "",
	"CSV": "",
	"XLSX": "",

	// Scrollbar-related
	"Use TAB to select grip buttons or left and right arrows to change selection": "",
	"Use left and right arrows to move selection": "",
	"Use left and right arrows to move left selection": "",
	"Use left and right arrows to move right selection": "",
	"Use TAB select grip buttons or up and down arrows to change selection": "",
	"Use up and down arrows to move selection": "",
	"Use up and down arrows to move lower selection": "",
	"Use up and down arrows to move upper selection": "",
	"From %1 to %2": "Dari %1 kepada %2",
	"From %1": "Dari %1",
	"To %2": "Kepada %2",

	// Data loader-related
	"No parser available for file: %1": "",
	"Error parsing file: %1": "",
	"Unable to load file: %1": "",
	"Invalid date": "Tarikh tidak sah"
};


// WEBPACK FOOTER //
// ../../../src/lang/en_MY.ts